export enum MeasurementType {
  DISTANCE = 'distance',
  SPEED = 'speed',
  NONE = 'none',
}

export const SETTING_MEASUREMENT_MAP: Record<string, MeasurementType> = {
  deliveryAltitude:  MeasurementType.DISTANCE,
  flightAltitude:    MeasurementType.DISTANCE,
  minReturnAltitude: MeasurementType.DISTANCE,
  deliveryRadius:    MeasurementType.DISTANCE,
  visibility:        MeasurementType.DISTANCE,
  deliverySpeed:     MeasurementType.SPEED,
  windGust:          MeasurementType.SPEED,
  windSpeed:         MeasurementType.SPEED,
};
